import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "align-content-top position-fixed mt-2 ms-8 w-1" }
const _hoisted_2 = {
  class: "badge custom-steper-active badge-highligthed-red",
  style: {"font-size":"7px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "align-content-center d-flex align-items-center ms-1 ms-lg-3 fill-svg-inactive me-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M381.7 225.9c0-97.6-52.5-130.8-101.6-138.2 0-.5.1-1 .1-1.6 0-12.3-10.9-22.1-24.2-22.1-13.3 0-23.8 9.8-23.8 22.1 0 .6 0 1.1.1 1.6-49.2 7.5-102 40.8-102 138.4 0 113.8-28.3 126-66.3 158h384c-37.8-32.1-66.3-44.4-66.3-158.2zM256.2 448c26.8 0 48.8-19.9 51.7-43H204.5c2.8 23.1 24.9 43 51.7 43z" })
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "badge custom-steper-active badge-highligthed-red",
  style: {"font-size":"7px","display":"none"}
}
const _hoisted_5 = {
  key: 1,
  class: "badge custom-steper-active badge-highligthed-red",
  style: {"font-size":"7px","display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "d-flex me-2",
      style: {"cursor":"pointer"},
      onClick: _cache[0] || (_cache[0] = () => _ctx.gotToNotificationAlert())
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.size2?.data?.data != null? _ctx.size2?.data?.data?.length: 0), 1)
      ]),
      _hoisted_3
    ]),
    (_ctx.size)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.size), 1))
      : _createCommentVNode("", true),
    (_ctx.size)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.size2), 1))
      : _createCommentVNode("", true)
  ], 64))
}